import { render, staticRenderFns } from "./Counters.vue?vue&type=template&id=34349ac7&scoped=true&"
import script from "./Counters.vue?vue&type=script&lang=js&"
export * from "./Counters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34349ac7",
  null
  
)

export default component.exports